import { fetchApi } from '@/config/axiosSetting';
import {
  GetAlertInitialBodyQueryParamsType,
  GetAlertInitialBodyQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getAlertInitialBody/getAlertInitialBodyQuery.type';

export const getAlertInitialBodyFunction = (
  params: GetAlertInitialBodyQueryParamsType,
): Promise<GetAlertInitialBodyQueryResponseType> => {
  return fetchApi.get(`initial/reports/${params.id}/alerts/`, { params });
};
